import type { Notification } from 'src/context/api/data/api';
import { filterByType } from './notifications.utils';

// Cards a list never renders: `dismissed` notifications are filtered out of
// every list, so they must not be counted either.
function countRendered(list: Notification[]): number {
  return list.filter((n) => n.status !== 'dismissed').length;
}

// Pure derivation of per-tab counts from the single visible-notifications set.
// Each count is the number of cards the matching list actually renders — read
// ones included — so the bell badge equals what the user sees in the all tab.
// Non-notification cards rendered alongside them (pending invitations in the
// all tab, live jobs in the export tab) are passed in by the caller.
export function computeTabCounts(
  visible: Notification[],
  extraCards: { invitations?: number; activeExportJobs?: number } = {},
) {
  const { invitations = 0, activeExportJobs = 0 } = extraCards;
  return {
    all: countRendered(visible) + invitations,
    brandInfringement: countRendered(filterByType(visible, 'brand_infringement')),
    export: countRendered(filterByType(visible, 'export')) + activeExportJobs,
    // The onboarding tab splits its cards across an unread and a read
    // sub-list; the count covers both, matching their union.
    onboard: filterByType(visible, 'onboarding').length,
  };
}
